<div class="content-section-layout">
  @if (headline()) {
    <header class="content-section-layout__header">
      <div class="content-section-layout__header__left">
        <h2 class="content-section-layout__header__headline">
          {{ headline() }}
        </h2>
      </div>
      <div class="content-section-layout__header__meta">
        <ng-content select="content-section-layout-header-meta" />
      </div>
      <div class="content-section-layout__header__buttons">
        <ng-content select="content-section-layout-header-buttons" />
      </div>
    </header>
  }
  <div class="content-section-layout__main">
    <ng-content />
  </div>
</div>
